import React from 'react';
import type { TFunction } from 'i18next';

export interface EmployeeAdjusterProps {
  count: number;
  onDecrement: () => void;
  onIncrement: () => void;
  t: TFunction;
}

export function EmployeeAdjuster({ count, onDecrement, onIncrement, t }: EmployeeAdjusterProps): React.ReactElement {
  return (
    <div className="mb-3.5 rounded-lg border border-hairline" style={{ background: "#F9FAFB", padding: "16px 20px" }}>
      <div className="flex items-center justify-between gap-5">
        <div>
          <div className="text-small font-bold text-ink">{t("cart.adjustEmployee")}</div>
          <div className="mt-0.5 text-tiny text-sub">{t("cart.adjustEmployeeHint")}</div>
        </div>
        <div className="flex items-center rounded-[10px] border border-stroke bg-white" style={{ boxShadow: "0 1px 2px rgba(0,0,0,0.05)" }}>
          <button onClick={onDecrement} className="cursor-pointer border-none bg-transparent border-r border-hairline font-medium text-ink font-sans" style={{ width: 34, height: 36, fontSize: 16 }}>−</button>
          <span className="font-extrabold text-ink" style={{ fontSize: 15, padding: "0 16px" }}>{count}</span>
          <button onClick={onIncrement} className="cursor-pointer border-none bg-transparent border-l border-hairline font-medium text-ink font-sans" style={{ width: 34, height: 36, fontSize: 16 }}>+</button>
        </div>
      </div>
    </div>
  );
}
